import React from 'react';
import Images from '../../components/Images/Images';
import Rates from '../../components/Rates/Rates';

import './jobDetails.css';

export default function JobDetails({ data, handleShowJobDetails }) {

  let closeOutButton;
  if (data.is_today) {
    closeOutButton = {
      backgroundColor: '#0C3330'
    };
  } else {
    closeOutButton = {
      backgroundColor: '#C6C6C6'
    };
  }

  return (
    <main className="job_details pt-3">
      <div className="job_details_container">
        <header className="container px-3 py-4">
          <div className="row">
            <div className="col-1">
              <div onClick={handleShowJobDetails}>
                <i className="fas fa-chevron-left text-white ml-2"></i>
              </div>
            </div>
            <div className="col-10">
              <h5 className="text-white text-center">{data.name}</h5>
            </div>
          </div>
        </header>
        <section className="container mt-4">
          <div className="row">
            <div className="col-6 pl-4">
              <p className="d-flex justify-content-start align-items-center mb-3">
                <span className="bg-jungle-green circle-icon sm m-0">
                  <i className="icon icon-calendar text-light-blue"></i>
                </span>
                <span className="ml-3 font-weight-bold">Date</span>
              </p>
              <p className="text-left">{data.date}</p>
            </div>
            <div className="col-1 pl-0">
              <p>.</p>
            </div>
            <div className="col-5 pr-3 pl-0">
              <a href={data.is_today ? data.closeout_process_link : null}>
                <button
                  type="button"
                  className="close-out-button btn btn-block btn-lg text-small text-white"
                  style={closeOutButton}
                >
                  Close Out
                  <i className="fas fa-chevron-right ml-2"></i>
                </button>
              </a>
            </div>
          </div>
        </section>
        <hr className="mx-4" />
        <section className="container mt-4">
          <div className="row">
            <div className="col-6 pl-4">
              <p className="d-flex justify-content-start align-items-center mb-3">
                <span className="bg-jungle-green circle-icon sm m-0">
                  <i className="icon icon-house-leaf text-light-blue"></i>
                </span>
                <span className="ml-3 font-weight-bold">Address</span>
              </p>
              <p className="text-left">
                <span>{data.address}</span><br />
                <span>{data.city}</span><br />
                <span>{data.postcode}</span>
              </p>
            </div>
            <div className="col-1 pl-0">
              <p>.</p>
            </div>
            <div className="col-4 pl-0">
              <p className="d-flex justify-content-start align-items-center mb-3">
                <span className="bg-jungle-green circle-icon sm m-0">
                  <i className="icon icon-phone text-light-blue"></i>
                </span>
                <span className="ml-3 font-weight-bold">Phone</span>
              </p>
              <a href={`tel:${data.phone}`}>
                <p className="text-left">{data.phone}</p>
              </a>
            </div>
          </div>
        </section>
        <hr className="mx-4" />
        <section className="container mt-4">
          <div className="row">
            <div className="col-1 pl-4">
              <div className="bg-jungle-green circle-icon sm">
                <i className="icon icon-clock text-light-blue"></i>
              </div>
            </div>
            <div className="col-10 mt-1 text-center">
              <p>Time to destination:</p>
              <p className="font-weight-bold">{data.travel_time}</p>
            </div>
          </div>
        </section>
        <hr className="mx-4" />
        <section className="container mt-4 mb-4">
          <div className="ml-2">
            <p className="d-flex justify-content-start align-items-center mb-3">
              <span className="bg-jungle-green circle-icon sm m-0">
                <i className="icon icon-circle-tick text-light-blue"></i>
              </span>
              <span className="ml-3 font-weight-bold">Job Status</span>
            </p>
            <div className="job_details_status w-100 border border-dark d-flex justify-content-center align-items-center">
              <h4 className="m-0">{data.status}</h4>
            </div>
          </div>
        </section>
        <hr className="mx-4" />
        <section className="container mt-4">
          <div className="ml-2">
            <p className="d-flex justify-content-start align-items-center mb-3">
              <span className="bg-jungle-green circle-icon sm m-0">
                <i className="icon icon-tools text-light-blue"></i>
              </span>
              <span className="ml-3 font-weight-bold">Job Details</span>
            </p>
            <div className="row">
              <div className="col-6">
                <ul className="pl-3 text-left">
                  <li>Roof access:</li>
                  <li>No. of panels:</li>
                  {data.most_common_roof_type && <li>Roof type:</li>}
                </ul>
              </div>
              <div className="col-6 pr-4">
                <p className="font-weight-bold text-right">{data.scaffolding_type}</p>
                <p className="font-weight-bold text-right">{data.total_panels}</p>
                <p className="font-weight-bold text-right">{data.most_common_roof_type}</p>
              </div>
            </div>
          </div>
        </section>
        <hr className="mx-4" />
        <section className="container mt-4">
          <p className="d-flex justify-content-start align-items-center mb-3">
            <span className="bg-jungle-green circle-icon sm m-0">
              <i className="icon icon-solar-panel text-light-blue"></i>
            </span>
            <span className="ml-3 font-weight-bold">Kit</span>
          </p>
          <div className="row align-items-center">
            <div className="col-8">
              <ul className="pl-4 text-left">
                <li>Kit delivered:</li>
                <li>Checked by customer:</li>
              </ul>
            </div>
            <div className="col-4">
              <p className="font-weight-bold text-left">
                <span className="bg-jungle-green circle-icon sm mr-3">
                  <i className="icon icon-circle-tick text-light-blue"></i>
                </span>
              </p>
              <p className="font-weight-bold text-left">
                <span className="bg-jungle-green circle-icon sm mr-3">
                  <i className="icon icon-circle-tick text-light-blue"></i>
                </span>
              </p>
            </div>
          </div>
        </section>
        <hr className="mx-4" />
        <Images
          images={data.all_images_url}
          panel_placement={data.panel_placement_url}
          solar_edge={data.solar_edge_url}
        />
        <hr className="mx-4" />
        {data.rates && <Rates rates={data.rates} />}
        <footer className="w-100"></footer>
      </div>
    </main>
  )
}
